import * as constants from '../constants';

const initialState = {
    data: [],
    item: {}
};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getPesticideHarmfulObject.success: {
            return {
                ...state, data: action.payload.results
            };
        }

        case constants.getPesticideHarmfulObjectItem.success: {
            return {
                ...state, item: { ...action.payload }
            };
        }

        default:
            return state;
    }
}
